var React = require('react');

function IconCart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#313F65","fillRule":"evenodd"},React.createElement("path",{"d":"M3.992 2.71C2.919.648 1.795-.21.62.14.155.266-.092.76.032 1.226c.123.464.618.712 1.083.588.402-.124 1.02.898 1.237 1.517l.247.62 4.053 10.31c.279.774.743 2.043 2.29 2.043h9.467c1.516 0 2.01-1.27 2.289-2.012l1.772-4.509 2.28-5.802h-1.794l-4.008 9.945a2.196 2.196 0 0 1-.294.545c-.032.04-.095.064-.189.071H8.942a.338.338 0 0 1-.26-.103 2.27 2.27 0 0 1-.243-.447L5.18 5.69 3.992 2.71zM16.552 17.48a1.578 1.578 0 1 1 0 3.156 1.578 1.578 0 0 1 0-3.156M10.829 17.48a1.578 1.578 0 1 1-.001 3.156 1.578 1.578 0 0 1 0-3.156"})));
}

IconCart.displayName = "IconCart";

IconCart.defaultProps = {"width":"25","height":"21","viewBox":"0 0 25 21"};

module.exports = IconCart;

IconCart.default = IconCart;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./app/javascript/images/icons/icon-cart.svg
// module id = 843
// module chunks = 0 1